/**
 * 创作方-数据统计
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const statisticNorRoutes: any = {
  path: 'statistic-nor',
  name: '数据统计-创作',
  icon: 'ift-stat_2',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '数据统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-statisticNorList',
          meta: {
            text: '数据总览',
            type: 'main',
            role: ['7002']
          },
          component: () => import('../views/statistic-nor/index.vue')
        },
        {
          path: 'stat-detail/:type',
          name: 'desk-statisticNorDetail',
          meta: {
            text: '项目明细',
            type: 'detail',
          },
          component: () => import('../views/statistic-nor/detail.vue')
        }
      ]
    },
    {
      path: 'comic-stat/:id',
      redirect: 'comic-stat/:id',
      name: '项目统计',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-statisticNorComicList',
          meta: {
            text: '项目数据',
            type: 'main',
            role: ['7002']
          },
          component: () => import('../views/statistic-nor/comic.vue')
        },
        {
          path: 'stat-detail/:type/:id',
          name: 'desk-statisticNorComicDetail',
          meta: {
            text: '项目明细',
            type: 'detail',
          },
          component: () => import('../views/statistic-nor/detail-comic.vue')
        },
        {
          path: 'stat-overdue-detail/:id',
          name: 'desk-statisticNorOverdueComicDetail',
          meta: {
            text: '逾期明细',
            type: 'detail',
          },
          component: () => import('../views/statistic-nor/overdue-detail-comic.vue')
        },
        {
          path: 'stat-approve-detail/:id/:time?/:userid?',
          name: 'desk-statisticNorApproveComicDetail',
          meta: {
            text: '审批明细',
            type: 'detail',
          },
          component: () => import('../views/statistic-nor/approve-detail-comic.vue')
        }
      ]
    },
  ]
};

export {
  statisticNorRoutes
};
